/** @format */

export enum AccessoriesFormCategory {
    CAMERA = 'CAMERA',
    CINECAMERA = 'CINECAMERA',
    LENS = 'LENS',
    DRONE = 'DRONE',
    CAMCORDER = 'CAMCORDER',
    OTHER = 'OTHER',
    NONE = 'NONE',
}
